import { Pipe, PipeTransform } from '@angular/core';
import { monthsHeb } from '../Utility/constants';

@Pipe({
	name: 'returnHebrewDate',
})
export class ReturnHebrewDatePipe implements PipeTransform {
	transform(value: number | string, mode: 'day' | 'month' = 'month', decrementByOne?: boolean): string | null {
		let checkValues = { min: 0, max: 11 };
		if (mode === 'month') {
			const arr = monthsHeb;
			value = decrementByOne ? +value - 1 : value;

			if ((typeof value === 'number' || !isNaN(+value)) && +value >= checkValues.min && +value <= checkValues.max) {
				return arr[+value];
			}
		}

		if (mode === 'day') {
			const days = ['ראשון', 'שני', 'שלישי', 'רביעי', 'חמישי', 'שישי', 'שבת'];
			checkValues = { min: 0, max: 6 };
			if ((typeof value === 'number' || !isNaN(+value)) && +value >= checkValues.min && +value <= checkValues.max) {
				return days[+value];
			}
		}

		return null;
	}
}
